import React, { useContext } from 'react';
import { Route } from "react-router-dom";
import redirect from '../components/redirect/redirect';
import message from '../components/message/message';
import Common from '../context/Common'

function Authenticate({component: Component, checkAuth = true, type, redirect: redirectLocation, message: messageAfter, props, updatePermissions, ...rest})
{
    const common = useContext(Common)
    let auth = common?.auth
    return (
        <Route
            {...rest}
            render={(additionalProps) => {
                
                if (checkAuth && auth != null && auth !== type)
                {
                    redirect.send(redirectLocation, () =>{
                        message.error(messageAfter)
                    })
                }
                return (
                    <Component updatePermissions={updatePermissions} auth={auth} {...additionalProps} {...props} />
                )
            }
            }
        />
    )
}


class CustomerRouteSkeleton extends React.Component
{
    static contextType = Common
    render()
    {
        var { component: Component, auth, props, updatePermissions, ...rest} = this.props

        return (
            <Authenticate component={Component}
                          type='customer'
                          redirect='/account/log-in/teacher'
                          message='You must login into your teacher account to access that page.'
                          props={props}
                          updatePermissions={updatePermissions}
                          {...rest} />
        )
    }
}

class GuestRouteSkeleton extends React.Component
{
    render()
    {
        var { component: Component, auth, props, updatePermissions, ...rest} = this.props

        return (
            <Authenticate component={Component}
                          type='guest'
                          checkAuth={false}
                          redirect='/dashboard'
                          message='You are already logged in'
                          props={props}
                          updatePermissions={updatePermissions}
                          {...rest} />
        )
    }
}

class StudentRouteSkeleton extends React.Component
{
    render()
    {
        var { component: Component, auth, ...rest} = this.props
        return (
            <Authenticate component={Component}
                          type='student'
                          redirect='/account/log-in/student'
                          message='You must login into your student account to access that page.'
                          {...rest} />
        )
    }
}


export {
    CustomerRouteSkeleton,
    GuestRouteSkeleton,
    StudentRouteSkeleton
}
